<template>
  <v-row class="mt-5 pt-5 px-5 mx-5">
    <v-col class="col-0 col-lg-2" v-if="!isMobile"></v-col>
    <v-col class="mt-5 pt-5 mx-5">
      <vue-typed-js
        :strings="['Revolucionando o mercado de soluções eletromecânicas ^500']"
        :loop="true"
        class="mx-auto mt-5"
        style="text-shadow:1px 1px 5px #111"
      >
        <div v-if="isMobile">
          <h2>
            <span class="typing" />
          </h2>
        </div>
        <div v-else>
          <h1>
            <span class="typing" />
          </h1>
        </div>
      </vue-typed-js>
    </v-col>
    <v-col class="col-2"></v-col>
  </v-row>
</template>
<script>
import Vue from "vue";
import VueTypedJs from "vue-typed-js";
Vue.use(VueTypedJs);

export default {
  props: {
    isMobile: Boolean
  }
};
</script>
